import{CdsInternalControlGroup as o}from"@cds/core/forms";class r extends o{}export{r as CdsCheckboxGroup};
